// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobileModal,\n.ModalRenameField {\n  width: 100% !important;\n  top: 100px !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n}\n.ModalRenameField {\n  max-width: 472px;\n}\n.ModalRenameField .label {\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 4px;\n}\n.ModalRenameField .label span {\n  color: #d40000;\n}", ""]);
// Exports
module.exports = exports;
